import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export type RetentionOverviewItem = {
  _id: string;
  userId: string;
  fallaufgabenId: string;
  fallaufgabenName: string;
  versionsUnique: string;
  created: string;
  isAdminTest: boolean;
  availableUntil: string;
};

@Injectable({
  providedIn: 'root'
})
export class RetentionOverviewService {
  public items: RetentionOverviewItem[] = [];
  private http = inject(HttpClient);
  private baseRoute = "/api/admin/fallaufgabenstatus";

  public async list() {
    this.items = await firstValueFrom(this.http.get<RetentionOverviewItem[]>(this.baseRoute + "/retention-overview"));
  }
}
